import { SVG_SIZE_M } from 'src/constants';
import { useColorTheme } from 'src/hooks';

export const KimiLogo = ({
  size = SVG_SIZE_M,
  color,
}: {
  size?: number;
  color?: string;
}) => {
  const { isDarkTheme } = useColorTheme();
  const COLOR = color ? color : isDarkTheme ? 'white' : 'black';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1313_7488)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6426 4.26557C12.7404 4.14017 12.8262 4.02557 12.9168 3.91457C12.9588 3.86237 12.9552 3.82277 12.9144 3.76817C12.5214 3.25157 12.4842 2.67797 12.7104 2.09597C12.8802 1.65797 13.2558 1.45277 13.7148 1.40897C14.001 1.38197 14.2818 1.41137 14.5422 1.55057C14.8842 1.73357 15.0834 2.01257 15.1482 2.39777C15.1998 2.70497 15.1902 3.00497 15.1032 3.30257C14.949 3.82937 14.5704 4.10237 14.0514 4.17137C13.6206 4.22897 13.1838 4.23617 12.7494 4.26557C12.7158 4.26797 12.6816 4.26557 12.6426 4.26557Z"
          fill={COLOR}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5774 1.5769H8.9818L6.9268 6.26291H4.0216V1.5973H1.7002V13.6705H4.0222V8.58431H8.1166C8.46246 8.58429 8.80111 8.48545 9.09269 8.29942C9.38426 8.1134 9.61662 7.84794 9.7624 7.53431V13.6705H12.0844V8.58431C12.0844 7.99773 11.8625 7.43288 11.4631 7.00325C11.0638 6.57362 10.5166 6.31105 9.9316 6.26831V6.2623H8.6566C8.96381 6.15735 9.24611 5.99025 9.48591 5.7714C9.72571 5.55256 9.91787 5.28667 10.0504 4.9903L11.5774 1.5769Z"
          fill={COLOR}
        />
      </g>
      <defs>
        <clipPath id="clip0_1313_7488">
          <rect
            width="14.4"
            height="14.4"
            fill="white"
            transform="translate(0.799805 0.800049)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
